import o from "./index239.js";
/* empty css         */
import e from "./index130.js";
const a = /* @__PURE__ */ e(o, [["__scopeId", "data-v-5e998ecc"]]);
export {
  a as default
};
